<template>
    <div>
        <PageHeaderLayout>
            <el-button type="" style="margin-bottom: 10px;" @click="goBack()" icon="el-icon-back" size="medium">
                返回
            </el-button>
            <div class="main-page-content" v-loading="loadingStaus" :element-loading-text="loadingText">
                <div>
                    <div class="name">
                        企业授权短信链接
                    </div>
                    <div v-if="statusList[authInfo.first_is_auth]">
                        {{statusList[authInfo.first_is_auth]}}
                    </div>
                    <div v-permission:company_examine_esign_launch>
                        <el-button v-if="authInfo.first_is_auth===0 || authInfo.first_is_auth===3" @click="postManagerEsignAuth" v-permission:company_examine_esign size="mini" type="primary">{{authInfo.first_is_auth==0?'发送授权':'重新发送授权'}}</el-button>
                        <el-button v-else-if="authInfo.first_is_auth==1" @click="showAuthUrl" v-permission:company_examine_esign size="mini" type="primary">查看授权链接</el-button>
                    </div>
                </div>
                <div>
                    <div class="not-auth-tips" v-if="showNotAuthTips">
                        未授权，暂无数据
                    </div>
                    <div v-else>
                        <div class="add-seal-btn">
                            <el-button @click="showAndHideForm" v-permission:company_examine_esign_establish type="primary">创建印章</el-button>
                        </div>
                        <ApeTable ref="apeTable" :data="cachetList" :columns="columns" v-permission:company_examine_esign_list
                            :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging"
                            highlight-current-row>
                            <el-table-column
                                width="240"
                                align="center"
                                label="印章图片">
                                <template slot-scope="scope">
                                    <el-image :preview-src-list="[scope.row.sealImageDownloadUrl]" class="expressImg" :src="scope.row.sealImageDownloadUrl" style="height: 60px;width: 60px;">
                                        <template #error>
                                          <div class="image-slot" @click="mxGoUrl(scope.row.sealImageDownloadUrl)">
                                            查看图片
                                          </div>
                                        </template>
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" header_align='center' align='center'
                                label="操作">
                                <template slot-scope="scope">
                                    <span>
                                            
                                        <el-popover v-if="scope.row.isAuth!=2"
                                          :ref="'el-popover-'+scope.$index"
                                          placement="top"
                                          width="150">
                                          <p>确定要授权吗？</p>
                                          <div style="text-align: right; margin: 0;">
                                            <el-button type="text" size="mini" @click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
                                            <el-button type="primary" size="mini" @click="sendSealAuth(scope.row.sealId)">确定</el-button>
                                          </div>
                                          <el-button v-permission:company_examine_esign_official_seal slot="reference" type="primary" size="mini">印章授权</el-button>
                                        </el-popover>
                                    </span>
                                </template>
                            </el-table-column>
                        </ApeTable>
                    </div>
                </div>
            </div>
        </PageHeaderLayout>
        
        <el-dialog :visible.sync="is_show_form" width="60%" title="创建公章">
            
            <tz-form align="center" ref="ref_form_update" :buttonArr="formButtonArr" @buttonTap="event_formTap" :comData="formData">
                <div slot="end">
                    <div class="agree-class">
                       横向文 : 可设置0-8个字，企业名称超出25个字后，不支持设置横向文。如合同专用章
                    </div>
                </div>
            </tz-form>
        </el-dialog>
        
        <el-dialog :visible.sync="is_show_url" width="60%" title="查看授权链接">
            <div class="auth-url-class">
                <div class="url">
                   {{authInfo.first_auth_url}}
                </div>
                <el-button type="primary" @click="showAuthUrl">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import PageHeaderLayout from '@/layouts/PageHeaderLayout'
    import ApeTable from "@/components/ApeTable";
    import tzForm from "@/components/tz-form";
    export default {
        components: {
            PageHeaderLayout,
            ApeTable,
            tzForm
        },
        data() {
            let sealTypeList=[
                {
                    label: '公章',
                    val: 'PUBLIC'
                },
                {
                    label: '合同专用章',
                    val: 'CONTRACT'
                },
                {
                    label: '人事专用章',
                    val: 'PERSONNEL'
                },
                {
                    label: '财务专用章',
                    val: 'FINANCE'
                },
                {
                    label: '其他',
                    val: 'COMMON'
                }
            ]
            let templateTypeList=[
                {
                    label: '圆章',
                    val: 'TEMPLATE_ROUND'
                },
                {
                    label: '椭圆章',
                    val: 'TEMPLATE_OVAL'
                }
            ]
            return {
                showNotAuthTips:false,
                is_show_url:false,
                formButtonArr:[
                    {
                        label: '确定',
                        type: 'primary',
                        flag: 'add'
                    }
                ],
                is_show_form:false,
                formData: [
                    {
                        label: '印章业务类型',
                        type: 'select',
                        field: 'seal_type',
                        val: 'PUBLIC',
                        filterable:true,
                        required: true,
                        typeData:sealTypeList
                    },
                    {
                        label: '印章样式',
                        type: 'select',
                        field: 'template_type',
                        val: 'TEMPLATE_ROUND',
                        filterable:true,
                        required: true,
                        typeData:templateTypeList
                    },
                    {
                        label: '印章横向文',
                        type: 'input',
                        field: 'htext',
                        val: '',
                        placeholder:'横向文，可设置0-8个字，企业名称超出25个字后，不支持设置横向文。如合同专用章',
                        required: false
                    },
                ],
                pagingData:{
                    is_show:false
                },
                columns: [
                    {
                        title: "印章ID",
                        value: "sealId",
                        header_align: "center",
                        align: "center",
                        width:180
                    },
                    {
                        title: "印章类型",
                        value: "sealTypeText",
                        header_align: "center",
                        align: "center",
                    },
                    {
                        title: "印章状态",
                        value: "statusDesc",
                        header_align: "center",
                        align: "center",
                    },
                    {
                        title: "印章创建时间",
                        value: "createDate",
                        header_align: "center",
                        align: "center",
                        width:140
                    },
                    {
                        title: "印章业务类型",
                        value: "sealBizTypeDesc",
                        header_align: "center",
                        align: "center",
                        width:140
                    },
                    {
                        title: "驳回原因",
                        value: "examineRemark",
                        header_align: "center",
                        align: "center",
                        width:140
                    }
                ],
                cachetList:[],//公章列表
                statusList:{
                    '0':'待认证',
                    '1':'认证中',
                    '2':'认证成功',
                    '3':'认证失败'
                },
                authInfo:{
                    first_is_auth:''
                }, //授权信息
                loadingStaus: false,
                loadingText: "",
                project_status: this.$route.query.project_status.toString() == 'true' ? true : false,
                company_id: this.$route.query.id
            }
        },
        computed: {},
        methods: {
            showAuthUrl(){
                this.is_show_url = !this.is_show_url
            },
            // 发送授权
            async sendSealAuth(id) {
              let data = {
                  seal_id:id,
                  company_id: this.company_id,
                  company_type: this.project_status ? 2 : 1
              }
              let result = await this.$api.sendSealAuth(data)
              if(result) {
                this.$message.success('已发起授权')
                this.init()
              }
            },
            async showAndHideForm(){
                this.is_show_form = !this.is_show_form
            },
            async event_formTap(e){
                switch (e.buttonData.flag) {
                    case 'add':
                        var data = e.data
                        this.createSeal(data)
                        break;
                    default:
                        break;
                }
            },
            // 创建
            async createSeal(data) {
                data.company_id = this.company_id;
                data.company_type = this.project_status ? 2 : 1
                let result = await this.$api.createSeal(data)
                if (result) {
                    this.$message.success("保存成功")
                    this.showAndHideForm()
                    this.formData.map(item => {
                        item.val = ''
                    })
                    this.initForm()
                    this.getSealList()
                }
            },
            async initForm(){
                this.formData.map(item => {
                    if(item.field=='seal_type'){
                        item.val = 'PUBLIC'
                    }else if(item.field=='template_type'){
                        item.val = 'TEMPLATE_ROUND'
                    }else{
                        item.val = ''
                    }
                })
            },
            // 创建
            async getSealList() {
                let data = {
                    company_id: this.company_id,
                    company_type: this.project_status ? 2 : 1,
                    page:1
                }
                let result = await this.$api.getSealList(data)
                if (result) {
                    this.cachetList = result.seals
                }
            },
            // 重置分页
            async resetPage() {
                this.$refs.apeTable.currentPage = 1
            },
            // 切换页码操作
            async switchPaging() {
                this.init();
            },
            async postManagerEsignAuth(){
                var that = this
                this.$confirm('点击确认按钮，发送企业授权短信链接', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: ''
                }).then(async () => {
                  if(!that.authInfo?.create_esign_company_info?.company_id){
                      return;
                  }
                  let data = {
                      ...that.authInfo.create_esign_company_info
                  }
                  let res = await that.$api.postManagerEsignAuth(data)
                  console.log(res)
                  if(res){
                      that.getAuthInfo()
                  }
                }).catch(() => {
                          
                });
                
            },
            // 初始化公司基本信息
            async getAuthInfo() {
                if (!this.company_id) {
                    return
                }
                let data = {
                    company_id: this.company_id,
                    company_type: this.project_status ? 2 : 1
                }
                let info = await this.$api.getAuthInfo(data)
                this.authInfo = info
                if(this.authInfo.first_is_auth==1 || this.authInfo.first_is_auth==2){
                    this.getSealList()
                }else{
                    this.showNotAuthTips = true
                }
            },
            //返回上一页
            goBack() {
                this.$router.push({
                    path: "/paihuo",
                    query: {
                        project_status: this.project_status
                    }
                });
            }
        },
        async mounted() {
            this.loadingStaus = true
            this.getAuthInfo()
            this.$nextTick(() => {
                this.loadingStaus = false
            })
        },
    }
</script>

<style lang="scss" scoped>
    .add-seal-btn{
        display: flex;
        justify-content: flex-end;
        margin: 26px;
        margin-top: 40px;
    }
    .not-auth-tips{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 160px;
        font-size: 22px;
    }
    .agree-class{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        margin-bottom: 40px;
    }
    .main-page-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        min-height: 750px;

        >div {
            border: 1px solid #dcdcdc;
            padding: 12px;

            &:first-child {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
            }

            &:nth-child(2) {
                flex: 1;
            }

            .name {
                font-size: 18px;
                font-weight: 500;
            }
        }

        padding: 20px;
        box-sizing: border-box;
    }
    
    .auth-url-class{
        display: flex;
        flex-flow: nowrap column;
        justify-content: center;
        align-items: center;
        
        .url{
            border: 1px solid #dcdcdc;
            border-radius: 8px;
            padding: 30px;
            font-size: 20px;
            margin-bottom: 40px;
        }
    }
</style>
